var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Clone Issue")]),_c('LoaderOverlay',{attrs:{"loading":_vm.loading}},[_c('IssueForm',{attrs:{"saveAction":"clone"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }